export const EDITABLE_TIER_PATTERN = /^(T[1-4]|Tier\s*[1-4])$/i;

export function getTierStyling(tier) {
  const match = tier?.toString().match(/(?:^T|^Tier\s*)([1-4])/i);
  const tierNum = match ? match[1] : null;
  switch (tierNum) {
    case '1':
      return 'bg-green-100 text-green-800 border-green-200';
    case '2':
      return 'bg-blue-100 text-blue-800 border-blue-200';
    case '3':
      return 'bg-yellow-100 text-yellow-800 border-yellow-200';
    case '4':
      return 'bg-gray-100 text-gray-800 border-gray-200';
    default:
      return 'bg-gray-100 text-gray-800 border-gray-200';
  }
}

export function isEditableTier(tier) {
  if (!tier || tier === 'N/A') return false;
  return EDITABLE_TIER_PATTERN.test(String(tier).trim());
}

export function hasDisplayableTier(tier) {
  if (!tier || tier === 'N/A') return false;
  const raw = String(tier).trim();
  if (!raw || /^tier$/i.test(raw)) return false;
  return true;
}

export function normalizeTier(tier) {
  if (!tier) return 'N/A';
  const raw = tier.toString().trim();
  if (/^Tier\s*\d+\s*[-–—]/.test(raw)) return raw;
  const match = raw.match(/Tier\s*(\d)/i);
  if (match) return `Tier ${match[1]}`;
  const tMatch = raw.match(/^T(\d)$/i);
  if (tMatch) return `Tier ${tMatch[1]}`;
  if (/^\d$/.test(raw)) return `Tier ${raw}`;
  return raw;
}

/** Select value for T1–T4 dropdowns. */
export function tierToSelectValue(tier) {
  if (!tier || tier === 'N/A') return '';
  const raw = String(tier).trim();
  const tMatch = raw.match(/^T(\d)$/i);
  if (tMatch) return `T${tMatch[1]}`;
  const tierMatch = raw.match(/Tier\s*(\d)/i);
  if (tierMatch) return `T${tierMatch[1]}`;
  if (/^(\d)$/.test(raw)) return `T${raw}`;
  return '';
}

export function tierSortNumber(tier) {
  const selectVal = tierToSelectValue(tier);
  const m = selectVal.match(/^T(\d)$/i);
  return m ? Number(m[1]) : 99;
}
